import React, { useContext } from 'react';
import { AppContext } from 'src/components/app-context';

import { StyledImageWrapper, StyledSotyBadge } from './styles';

type Props = {
  className?: string;
  imgUrl: string;
  name?: string | null;
  size?: number;
  year?: string;
};

export const SotyBadge = (props: Props) => {
  const { className, imgUrl, name, size = 115, year } = props;

  const { t, market } = useContext(AppContext);

  const altText = `${t('campaigns', 'shop-of-the-year.winners-title', {
    year: year || '',
  })}${name ? ` - ${name}` : null}`;

  // replaces soty badges img urls from 2010, 2011 and 2012 with generic badge
  // because badges for those years are missing on cdn.
  const url =
    year && parseInt(year, 10) < 2013
      ? `${market.cdn}/g/store_of_the_year/generic_store_of_the_year.png`
      : imgUrl;

  return (
    <StyledSotyBadge className={className}>
      <StyledImageWrapper size={size}>
        <img src={url} alt={altText} title={altText} />
      </StyledImageWrapper>
    </StyledSotyBadge>
  );
};
